import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from "@material-ui/core/Button";
import Typography from '@material-ui/core/Typography';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Image from 'material-ui-image'
import {Link} from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import ContactUs from "./ContactUs";
import {bindActionCreators} from "redux";
import {loginAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import * as MainConstants from "../../utils/MainConstants";



const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder)
    
});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    dividerColorPurpole: {
        //marginTop: theme.spacing.unit * 3,
        height: '20px',
        color:"#ffffff",
        //backgroundColor:"#760eb3",
    },
});


class SaveTime extends Component {
    
    state = {
        age: '',
        name: 'hai',
    };
    
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    constructor(props) {
        super(props);
        this.towAgentClick = this.towAgentClick.bind(this);
        this.vehicleOwnerClick = this.vehicleOwnerClick.bind(this);
    }
    
    
    towAgentClick(){
        //alert("was called") ;
        this.props.towAgentConfigCall();
        
    }
    
    vehicleOwnerClick(){
        //alert("was called") ;
        this.props.vehicleOwnerConfigCall();
        
    }
    
    
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    //The original picture was IMG_2977.JPG, IMG_3629_A
    render() {
        const { classes } = this.props;
        window.scrollTo(0, 0);
        return (
          <div  style={{ backgroundColor:"#F2F6F8" }}>
              
              <Grid container spacing={24}>
                  <Grid   item xs={12} sm={12}  md={8} lg={8} xl={8}>
                      <div  style={{ marginLeft:10, marginTop:10}}>
                          <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                              {MainConstants.APPLICATION_NAME}&trade;
                          </Typography>
                          <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  ,backgroundColor:'transparent' , color:'black'}} >For Municipality
                          </Typography>
                          <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'#e2580d'}} >
                              ________________
                          </Typography>
                          <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                              {/*<Text>When a city removes unnecessary traffic, it reduces traffic congestion  and improves the air quality. On average, a big city can reduce 800 metric tons of Co2 emissions every year
                                            by eliminating or reducing vehicle towing.</Text>*/}
                              {/*Reducing unnecessary towing helps cities alleviate traffic congestion and improve air quality. On average, a
                              large city can eliminate up to 800 metric tons of CO₂ emissions each year by minimizing
                              towing operations—equivalent to taking 140 cars off the road for an entire year.*/}
                              Reducing unnecessary towing helps cities ease congestion, lower emissions, and improve the overall urban experience.
                              By minimizing avoidable towing operations, a large city can reduce up to 800 metric tons of CO₂ annually—equivalent to removing approximately
                              140 vehicles from the road for an entire year.
                          </Typography>
                          <Typography variant="h5" component="h2" style = { {  color:'#BF360C' }}>
                              Benefits:
                          </Typography>
                          
                          <Typography  variant="subtitle1">
                              <ul>
                                   <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Ease Congestion - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Avoid tow truck staging, vehicle hook-ups, and temporary lane disruptions that slow traffic and create bottlenecks.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Reduce Unnecessary Vehicle Miles - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Eliminate an estimated 2,000,000 miles of avoidable vehicle movement annually, including tow trucks and displaced drivers.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Support Local Economic Activity - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Improved traffic flow makes it easier for residents and visitors to access local businesses.</span> </li>
                                  
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Lower Emissions  - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Fewer tow-related trips and reduced congestion lead to cleaner air and measurable environmental impact.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Improve Resident Experience  - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Fewer surprise tows mean fewer disputes, less frustration, and a more citizen-friendly city.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Enhance City Appeal  - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>A more efficient, sustainable, and predictable urban environment attracts residents, visitors, and investment.</span> </li>
                                  
                                  {/*<li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Ease Congestion - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Avoid vehicle hook-ups, temporary road closures, and lane blockages, helping maintain smooth traffic flow.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Reduce Traffic Volume - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Eliminate an estimated 2,000,000 miles of unnecessary vehicle movement annually.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Boost Economic Activity - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Less congestion means easier access to local businesses, improving economic vitality in your city.</span> </li>
                                  
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Protect the Environment  - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Fewer tow-related trips and reduced traffic jams result in lower emissions and cleaner air.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Enhance City Appeal  - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Improved traffic flow and air quality lead to happier residents, a healthier urban environment, and increased tourism and business investment.</span> </li>
                              
                                */}
                              </ul>
                          
                          </Typography>
                          
                          <a href="/home"  rel="noreferrer">
                              <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                                  &lArr; TowWatch Home
                              </Typography>
                          </a>
                          
                          {/*}
                                        <Card   display="inline-block" style = { {backgroundColor:'#f4f3ed', borderRadius:0,  color:'red',  width:"100%" }}>
                                    <CardContent>

                                        <Typography variant="h5" component="h2" style = { {  color:'#BF360C' }}>
                                            Benefits:
                                        </Typography>

                                        <Typography  variant="subtitle1">
                                            <ul>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Reduce Congestion - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> By not hooking a vehicle and reducing traffic jam</span> </li>

                                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Reduce Traffic - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Remove about 2,000,000 miles of  UNNECESSARY vehicle traffic every year</span> </li>

                                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Economic Affect - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Reducing traffic congestion, improves the economy of businesses in your city  </span> </li>


                                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Environment - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Reducing the trips to and from tow lot reduces toxic gas emissions</span> </li>

                                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Vastly Superior City - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Happier residents, better businesses, and more visitors to your city</span> </li>
                                        </ul>
                                            
                                            </Typography>


                                        </CardContent>
                                        <CardActions>
                                        
                                         <div style = { { paddingLeft:550}}>
                                        
                                        </div>
                                        </CardActions>
                                        </Card>   */}
                      </div>
                  </Grid>
                  <Grid   item xs={12} sm={12}  md={4} lg={4}  xl={4} >
                      <div  style={{ marginRight:10, marginLeft:10, marginTop:10, marginBotton:10}}>
                          <Image
                            src="/static/images/boston1.png"
                            aspectRatio='(9/6)'
                          />
                      </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                      <Divider className={classes.dividerColorPurpole}></Divider>
                      <div>
                          <ContactUs> </ContactUs>
                      </div>
                  </Grid>
              
              </Grid>
          </div>
        
        
        );
    }
}

const mapStateToProps = (state) => {
    return {
    
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loginAction:loginAction,
        
        
    }, dispatch);
};

SaveTime.propTypes = {
    classes: PropTypes.object.isRequired,
};
//export default BiomassView;
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SaveTime));
